import React from 'react'
import clsx from 'clsx'
import IconWrapper from '@/shared/components/UI/IconWrapper'

const ButtonIcon = ({
  icon: Icon,
  label,
  size = 'sm',
  onClick,
  disabled = false,
  className = '',
  ...props
}) => {
  const handleClick = (event) => {
    event.stopPropagation()
    if (disabled) return
    if (onClick) {
      onClick(event)
    }
  }

  // Helper to check if icon is a string and a link (http/https or data url)
  const isIconUrl = typeof Icon === 'string' && (
    Icon.startsWith('http://') ||
    Icon.startsWith('https://') ||
    Icon.startsWith('data:')
  )

  const sizeClasses = {
    xs: 'size-5', //20px
    sm: 'size-8', //32px
    md: 'size-9', //36px
    lg: 'size-10', //40px
    xl: 'size-14', //56px
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className={clsx(
        'flex',
        !label && 'justify-center', // Only center when no label
        'items-center',
        'gap-v3-xs',
        !label && 'aspect-square', // aspect-ratio: 1/1 only when no label
        label && 'px-v3-sm py-v3-xs', // Add padding when label is present
        'bg-transparent',
        'border-none',
        'outline-none',
        'cursor-pointer',
        'transition-all',
        'duration-200',
        'hover:bg-v3-black-border',
        'hover:rounded-v3-xs',
        'disabled:opacity-50',
        'disabled:cursor-not-allowed',
        'disabled:hover:bg-transparent',
        'flex-shrink-0',
        !label && sizeClasses[size], // Apply size classes only when no label
        className
      )}
      {...props}
    >
      {isIconUrl ? (
        <img 
          src={Icon} 
          className={clsx(
            'flex-shrink-0',
            disabled && '[&_*]:fill-v3-black-border' // Apply fill color to SVG elements when disabled
          )} 
          alt="icon" 
          style={disabled ? { fill: 'var(--v3-black-border, #E8EAED)' } : undefined}
        />
      ) : typeof Icon === 'function' ? (
        <IconWrapper size={20}>
          {React.createElement(Icon, {
            className: clsx(
              disabled && '[&_path]:fill-v3-black-border [&_*]:fill-v3-black-border', // Apply fill to path and all children when disabled
              disabled && 'text-v3-black-border' // Also apply text color for stroke-based icons
            ),
            style: disabled ? { fill: 'var(--v3-black-border, #E8EAED)' } : undefined
          })}
        </IconWrapper>
      ) : Icon ? (
        <IconWrapper size={20}>
          <div
            className={clsx(
              disabled && '[&_path]:fill-v3-black-border [&_*]:fill-v3-black-border',
              disabled && 'text-v3-black-border'
            )}
            style={disabled ? { fill: 'var(--v3-black-border, #E8EAED)' } : undefined}
          >
            {Icon}
          </div>
        </IconWrapper>
      ) : null}
      {label && (
        <span className="font-inter-variable text-[13px] font-medium leading-4 whitespace-nowrap">
          {label}
        </span>
      )}
    </button>
  )
}

export default ButtonIcon

